<!--
 * @Author: cheesekun
 * @Date: 2021-04-07 16:16:15
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-25 21:37:23
 * @FilePath: \dc-vizier-tpl-h5\src\views\Home\index.vue
-->
<template>
  <!-- 一屏就不分组件 -->
  <div class="home-container">
    <ul
      class="link"
      v-if="!mobile"
    >
      <a href="https://www.facebook.com/HeroBumpMobile/"></a>
      <a href="https://www.youtube.com/channel/UCVbShNqWp2uFtNIToMmKh8Q"></a>
      <a href="https://www.instagram.com/herobump/"></a>
      <a href="https://discord.gg/Un88zRjSbG"></a>
    </ul>
    <!-- 第一屏开始 -->
    <div class="header">
      <Top />
      <!-- <img
        class="first"
        :src="first"
        alt=""
      /> -->
      <div v-if="!mobile">
        <video
          class="video-box"
          preload="auto"
          loop
          playsinline
          autoplay
          muted
          poster="../../assets/pc/header.jpg"
          src="https://wsy-website.dianchu.com/hero-bump/video/video.mp4"
          tabindex="-1"
        ></video>
      </div>
      <div class="download">
        <a
          href="https://herobump.onelink.me/ezuN/ef32f62"
          class="apple"
        ></a>
        <a
          href="https://herobump.onelink.me/ezuN/ef32f62"
          class="google"
        ></a>
      </div>
      <div
        v-if="!mobile"
        class="next"
      ></div>
    </div>
    <!-- 第二屏开始 -->
    <!-- <div :class="['second', store.globalData.lang]"></div> -->
    <img
      class="second"
      :src="second"
      alt=""
    />
    <!-- 第三屏开始 -->
    <div class="third">
      <!-- 轮播游戏 -->
      <div class="game-info-block swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide swiper-block"
            v-for="(item, index) in 5"
            :key="index + '00'"
          >
            <div
              class="game-info-pc"
              v-if="!mobile"
            >
              <img
                class="game-text-img"
                :src="imgTextList[index]"
                alt=""
              />
            </div>
            <div
              class="game-info"
              v-if="mobile"
            >
              <span
                v-if="!mobile"
                class="title"
              >{{
                $t(`title${index}`)
              }}</span>
              <p>
                {{ $t(`text${index}`) }}
              </p>
            </div>
            <img
              class="game-img"
              :src="imgList[index]"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 移动端 -->
      <div
        class="game-app-list swiper-container"
        v-if="mobile"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide item"
            v-for="(item, index) in 5"
            :key="index + '0'"
            @click="switchAppSlide(index)"
          >
            <img
              class="game-img"
              :src="imgList[index]"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- pc端 -->
      <div
        class="game-list"
        v-if="!mobile"
      >
        <div
          class="item"
          v-for="(item, index) in 5"
          :key="index + '0'"
          @click="switchSlide(index)"
        >
          <div> <img
            :src="imgList[index]"
            alt=""
          /></div>
          <!-- <span class="game-list-sp">{{ $t(`title${index}`) }}</span> -->
          <img
            class="game-list-sp"
            :src="imgTitelList[index]"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 第四屏 -->
    <div class="four">
      <div :class="['title', store.globalData.lang]"></div>
      <div
        class="poster"
        v-if="!videoVisible"
      >
        <i
          class="play-btn"
          @click="play"
        ></i>
      </div>
      <div
        class="poster hidden"
        :class="[{'shown':videoVisible,}]"
      >
        <video
          ref="video"
          id="player"
          width="100%"
          height="100%"
          preload="auto"
          poster="../../assets/pc/poster.png"
          x5-playsinline="true"
          playsinline="true"
          webkit-playsinline="true"
          x5-video-player-fullscreen="true"
          controls
          src="http://dchk-platform.oss-cn-hongkong.aliyuncs.com/hero_bump/video/heroBump.mp4"
        >
          <source
            src="http://dchk-platform.oss-cn-hongkong.aliyuncs.com/hero_bump/video/heroBump.mp4"
            type="video/mp4"
          />
          <span>对不起，当前浏览器不支持播放视频</span>
        </video>
        <!-- <i class="play-btn" @click="play"></i> -->
      </div>
    </div>
    <div>
      <img :src="aboutUsImg" alt="about us" />
    </div>

    <ul
      class="app"
      v-if="mobile"
    >
      <a href="https://www.facebook.com/HeroBumpMobile/"></a>
      <a href="https://www.youtube.com/channel/UCVbShNqWp2uFtNIToMmKh8Q"></a>
      <a href="https://www.instagram.com/herobump/"></a>
      <a href=""> </a>
      <a href="https://m.me/HeroBumpMobile"> </a>
    </ul>
    <Footer />
  </div>
</template>

<script>
import Top from '@/components/Top'
import Footer from '@/components/footer'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import { userAgent } from '../../utils/index.js'
export default {
  name: 'Home',
  components: {
    Top,
    Footer
  },
  data () {
    return {
      mySwiperInformation: null,
      myAppSwiperInformation: null,
      type: this.store.globalData.lang,
      // second: require(`../../assets/pc/${this.store.globalData.lang}/second.jpg`),
      videoVisible: false,
      scrolled: false,
      userAgent: null
    }
  },
  computed: {
    mobile () {
      return userAgent().mobile
    },
    first () {
      return require(`../../assets/${this.mobile ? 'app' : 'pc'}/header.jpg`)
    },
    second () {
      return require(`../../assets/${this.mobile ? 'app' : 'pc'}/${this.store.globalData.lang
        }/second.jpg`)
    },
    aboutUsImg () {
      return require(`../../assets/${this.mobile ? 'app' : 'pc'}/${this.store.globalData.lang}/about-us.jpg`)
    },
    imgList () {
      return [
        require(`../../assets/pc/${this.store.globalData.lang}/g1.jpg`),
        require(`../../assets/pc/${this.store.globalData.lang}/g2.jpg`),
        require(`../../assets/pc/${this.store.globalData.lang}/g3.jpg`),
        require(`../../assets/pc/${this.store.globalData.lang}/g4.jpg`),
        require(`../../assets/pc/${this.store.globalData.lang}/g5.jpg`)
      ]
    },
    imgTextList () {
      return [
        require(`../../assets/pc/${this.store.globalData.lang}/f1.png`),
        require(`../../assets/pc/${this.store.globalData.lang}/f2.png`),
        require(`../../assets/pc/${this.store.globalData.lang}/f4.png`),
        require(`../../assets/pc/${this.store.globalData.lang}/f3.png`),
        require(`../../assets/pc/${this.store.globalData.lang}/f5.png`)
      ]
    },
    imgTitelList () {
      return [
        require(`../../assets/pc/${this.store.globalData.lang}/t1.png`),
        require(`../../assets/pc/${this.store.globalData.lang}/t2.png`),
        require(`../../assets/pc/${this.store.globalData.lang}/t4.png`),
        require(`../../assets/pc/${this.store.globalData.lang}/t3.png`),
        require(`../../assets/pc/${this.store.globalData.lang}/t5.png`)
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initSwiper()
    })
    this.mobile && this.initGameSwiper()
  },
  methods: {
    handleAlert () {
      const text = this.store.globalData.lang === 'zhCHT' ? '暂未开放' : 'Not yet open'
      alert(text)
    },
    initSwiper () {
      const that = this
      this.mySwiperInformation = new Swiper('.game-info-block', {
        observer: true,
        observeParents: true,
        autoplay: false,
        loop: false,
        initialSlide: that.mobile ? 1 : 0,
        slidesPerView: 1,
        centeredSlides: true,
        on: {
          slideChangeTransitionStart () {
            that.mobile &&
              that.myAppSwiperInformation &&
              that.myAppSwiperInformation.slideTo(this.activeIndex)
          }
        }
      })
    },
    initGameSwiper () {
      const that = this
      this.myAppSwiperInformation = new Swiper('.game-app-list', {
        observer: true,
        observeParents: true,
        // autoplay: false,
        // autoplay: {
        //   disableOnInteraction: false
        // },
        slidesPerView: 3,
        slidesPerGroup: 1,
        initialSlide: 1,
        loop: false,
        centeredSlides: true,
        on: {
          slideChangeTransitionStart () {
            that.mySwiperInformation &&
              that.mySwiperInformation.slideTo(this.activeIndex)
          }
        }
      })
    },
    switchSlide (index) {
      this.mySwiperInformation.slideTo(index)
    },
    switchAppSlide (index) {
      this.myAppSwiperInformation.slideTo(index)
    },
    play () {
      this.videoVisible = true
      this.$refs.video.play()
    },
    close () {
      this.$refs.video.pause()
      document.getElementById('myVideo').currentTime = 0
      this.videoVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../styles/mixin.less');

.video-box {
  width: 100%;
}
.hidden {
  display: none;
}
.shown {
  display: block;
}
@keyframes downup {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(0, 10px, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
.fun(@multiple) {
  .home-container {
    width: 100%;
    .header {
      position: relative;
      width: 100%;
      img {
        width: 100%;
      }
      .download {
        position: absolute;
        bottom: 136px;
        width: 640px;
        left: 50%;
        transform: translate(-50%, 0);
        .flex(@around);
        justify-content: space-evenly;
        a {
          width: 259px * @multiple;
          height: 77px * @multiple;
          &.apple {
            background: url('../../assets/apple.png') no-repeat;
            background-size: 100% 100%;
          }
          &.google {
            background: url('../../assets/google.png') no-repeat;
            background-size: 100% 100%;
          }
          &:hover {
            background-color: #000;
            border-radius: 10px;
            opacity: 0.8;
          }
        }
      }
      .next {
        position: absolute;
        left: 50%;
        margin-left: -26px;
        bottom: 60px;
        width: 52px;
        height: 44px;
        background: url('../../assets/pc/next.png') no-repeat;
        animation: downup 1s infinite;
      }
    }
    // .second {
    //   position: relative;
    //   width: 100%;
    //   height: 812px * @multiple;
    //   .mixin-lang-bg("/assets/pc/{lang}/second.jpg");
    //    background-repeat: no-repeat;
    //    background-size:cover;
    // }
    img {
      width: 100%;
      margin-top: -2.5px;
    }
    .third {
      width: 100%;
      height: 853px * @multiple;
      .game-info-block {
        position: relative;
        top: 40px * @multiple;
        height: 461px * @multiple;
        width: 1630px * @multiple;
        margin: 0 auto;

        .swiper-block {
          width: 100%;
          .flex(@around);
          justify-content: space-between;
        }
        .game-info-pc {
          padding-left: 143px;
        }
        .game-info {
          // width: 50%;
          flex: 1;
          height: 100%;
          .flex(@center);
          flex-direction: column;
          text-align: center;
          span {
            font-size: 41px * @multiple;
            font-weight: bold;
          }
          p {
            margin: 80px * @multiple 0 0 0;
            text-align: left;
          }
        }
        .game-img {
          // margin-right: 4px * @multiple;
          width: 641px * @multiple;
          cursor: pointer;
          padding-right: 11px;
        }
        .game-text-img {
          width: 90%;
        }
      }
      .game-list {
        width: 1630px * @multiple;
        margin: 100px * @multiple auto 0;
        .flex(@around);
        .item {
          width: 306px * @multiple;
          div {
            flex: 1;
            width: 100%;
            height: 177px * @multiple;
            overflow: hidden;
            img {
              flex: 1;
              width: 100%;
              height: auto;
              cursor: pointer;
              transition: all 1s ease-out;
              &:hover {
                transform: scale(1.08);
              }
            }
          }

          // }
          span {
            text-align: center;
            display: block;
            padding: 20px * @multiple 0 0;
            color: #000;
          }
        }
      }
      .game-list-sp {
        height: 15px !important;
        width: auto !important;
        margin-top: 20px;
      }
    }
    .four {
      width: 100%;
      height: 1022px * @multiple;
      background: url('../../assets/four.jpg');
      background-size: 100%;
      .title {
        width: 452px * @multiple;
        height: 37px * @multiple;
        .mixin-lang-bg('/assets/pc/{lang}/title4.png');
        margin: 60px * @multiple auto 40px * @multiple;
        background-size: 100% 100%;
        &.zhCHT {
          width: 268px * @multiple;
          height: 42px * @multiple;
        }
      }
      .poster {
        margin: 0 auto;
        width: 1200px * @multiple;
        height: 675px * @multiple;
        background: url('../../assets/pc/poster.png');
        background-size: 100%;
        position: relative;
        .play-btn {
          position: absolute;
          width: 148px * @multiple;
          height: 146px * @multiple;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          background: url('../../assets/play.png');
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
    }
    .link {
      position: fixed;
      right: 0;
      top: 50%;
      margin-top: -(150px * @multiple);
      width: 80px * @multiple;
      height: 300px * @multiple;
      background: url('../../assets/pc/yellowbg1.png') no-repeat;
      z-index: 100;
      a {
        display: block;
        width: 56px * @multiple;
        height: 56px * @multiple;
        margin: 15px * @multiple auto;
        cursor: pointer;
        &:nth-child(1) {
          background: url('../../assets/fb.png') no-repeat;
          background-size: 100% 100%;
        }
        &:nth-child(2) {
          background: url('../../assets/youtube.png') no-repeat;
          background-size: 100% 100%;
        }
        &:nth-child(3) {
          background: url('../../assets/ins.png') no-repeat;
          background-size: 100% 100%;
        }
        &:nth-child(4) {
          background: url('../../assets/discord.png') no-repeat;
          background-size: 100% 100%;
        }
        &:hover {
          background-color: #fff;
          opacity: 0.8;
          border-radius: 100%;
        }
      }
    }
    .video_dialog {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      video {
        width: 1000px * @multiple;
        height: 550px * @multiple;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
      }
    }
  }
}
.fun(1);
@media screen and (max-width: 1500px) {
  .fun(0.65);
}
@media screen and (min-width: 1500px) {
  .download {
    bottom: 196px !important;
  }
  .next {
    bottom: 120px !important;
  }
}
@media screen and (max-width: 750px) {
  .home-container {
    width: 100%;
    .header {
      position: relative;
      width: 100%;
      height: 13.32rem;
      background: url('../../assets/app/header.jpg') no-repeat;
      background-size: 100%;
      .download {
        position: absolute;
        bottom: 0.5rem;
        width: 7.2rem;
        left: 50%;
        transform: translate(-50%, 0);
        .flex(@around);
        justify-content: space-evenly;
        a {
          width: 3rem;
          height: 1.2rem;
          &.apple {
            background-size: contain;
          }
          &.google {
            background-size: contain;
          }
        }
      }
    }
    .second {
      position: relative;
      width: 100%;
      height: 6.35rem;
      .mixin-lang-bg('/assets/app/{lang}/second.jpg');
      background-size: 100% 100%;
    }
    .third {
      width: 100%;
      height: 7.48rem;
      .game-info-block {
        position: relative;
        top: 0.02rem;
        height: 5.6rem;
        width: 7rem;
        margin: 0 auto;
        font-size: 0.24rem;
        .swiper-block {
          width: 100%;
          .flex(@center);
          flex-direction: column-reverse;
        }
        .game-info {
          flex: 0;
          height: 1.8rem;
          .flex(@center);
          flex-direction: column;
          text-align: center;
          p {
            margin: 0.2rem 0 0 0;
          }
        }
        .game-img {
          // margin-right: 4px;
          width: 100%;
          height: 4rem;
        }
      }
      .game-list-sp {
        display: none !important;
      }
      .game-app-list {
        .item {
          width: 2.8rem;
          height: 1.4rem;
          padding: 0 0.1rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .four {
      width: 100%;
      height: 5.9rem;
      background: url('../../assets/app/four.jpg');
      background-size: cover;
      overflow: hidden;
      padding: 0.3rem 0 0.2rem 0;
      .title {
        width: 4.52rem;
        height: 0.37rem;
        .mixin-lang-bg('/assets/pc/{lang}/title4.png');
        background-size: 100%;
        margin: 0.36rem auto 0.24rem;
        &.zhCHT {
          width: 2.68rem;
          height: 0.42rem;
        }
      }
      .poster {
        margin: 0 auto;
        width: 6.69rem;
        height: 3.77rem;
        background: url('../../assets/app/poster.png');
        background-size: 100%;
        position: relative;
        .play-btn {
          position: absolute;
          width: 1.48rem;
          height: 1.48rem;
        }
      }
    }

    .app {
      position: relative;
      right: 0;
      width: 100%;
      height: 1.42rem;
      margin: 0.3rem 0;
      background: #fff;
      z-index: 100;
      .flex(@center);
      a {
        display: block;
        width: 0.78rem;
        height: 0.78rem;
        margin: 0 0.26rem;
        cursor: pointer;
        &:nth-child(1) {
          background: url('../../assets/app/fb.png') no-repeat;
          background-size: 100%;
        }
        &:nth-child(2) {
          background: url('../../assets/app/youtube.png') no-repeat;
          background-size: 100% 100%;
        }
        &:nth-child(3) {
          background: url('../../assets/app/ins.png') no-repeat;
          background-size: 100%;
        }
        &:nth-child(4) {
          background: url('../../assets/app/discord.png') no-repeat;
          background-size: 100%;
        }
        &:nth-child(5) {
          background: url('../../assets/app/lx.png') no-repeat;
          background-size: contain;
        }
      }
    }
    .video_dialog {
      video {
        width: 6.8rem;
        height: 4.2rem;
      }
    }
  }
}
</style>
